import { createPortal } from 'react-dom';
import { Context } from "./jobs-wrapper";
import { useState, useContext, useRef} from "react";
import {removeMainCat, getFullState,FixAnyOfTheseJobType, resetURLReplaceState, scrollToTopOfJobs} from '../helpers/helpers.js';

if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];
if (typeof window.were_facets_used === 'undefined') window.were_facets_used = false;


const Facets = () => {

    const {data, loading, updateJobParams, updatePageIndex} = useContext(Context);

    const [inputs, setInputs] = useState({"keywords" : window.kw_from_search}); //retains input information (keyword) - structure: {"keywords":"nurses"}
    const [checkboxes, setCheckboxes] = useState({}); //retains which checkboxes were clicked after a search  - structure:
    const [cityCheckboxValues, setCityCheckboxValues] = useState([]); //sets city dropdowns when a state is clicked - structure: [{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count:1,"state":"AK"}]
   
    const stateCheckboxValues = useRef([]); //retains state/city list after a filtered search - structure: [{"key":"AK","doc_count":57,"city-list":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count":1,"state":"AK"},{"key":"Barrow","doc_count":7,"state":"AK"}]
    const categoryCheckboxValues = useRef([]); //retains cat list after a filtered search - structure: [{"key":"Schools - Adaptive Physical Education Teacher","doc_count":3,"cleaned_key":"Adaptive Physical Education Teacher"}]
    const typeCheckboxValues = useRef([]); //sets type dropdowns when a type is clicked - structure: [{"key":"Contract","doc_count":19}]
    const firstFacetSelected = useRef(""); //sets the name of the first facet selected so we can make any of the first facet group checked "and" searches
    const stateFacetsChecked = useRef([0, 0]); //counts the number of checked states & checks the previous checked count . this is to decide if we should render the city facet after the data loads or before (to prevent city "flashes") only if we have a city checked prior should it not flash  
    const doCityFacetsExist = useRef(0);

    

    //console.log("firstFacetSelected.current: " + firstFacetSelected.current)

   
    if (typeof data.hits !== 'undefined' && firstFacetSelected.current === "") {
        categoryCheckboxValues.current = data.aggregations.categorieslist.buckets;
        typeCheckboxValues.current = data.aggregations.typelist.buckets;
        stateCheckboxValues.current = data.aggregations.stateslist.buckets;
    }


    if (!loading) {
        (document.querySelector(".job-results-column") !== null) && document.querySelector(".job-results-column").classList.remove("blurred");
    }
    else {
        //activate blurring
        (document.querySelector(".job-results-column") !== null) && document.querySelector(".job-results-column").classList.add("blurred");
    }

    const resetFacets = () => {
        document.querySelectorAll('.job-facets__filters-wrap input[type="checkbox"]').forEach(el=> {
            if (el.checked) el.click();
        })
        setCheckboxes({})
        setCityCheckboxValues([])
        typeCheckboxValues.current = [];
        stateCheckboxValues.current = [];
        categoryCheckboxValues.current = [];
        firstFacetSelected.current = "";
        stateFacetsChecked.current = [0, 0];
        window.were_facets_used = false;
        scrollToTopOfJobs();
    }

   /* this is used to populate city facets. -> updates city job counts and filters cities based on any cat and type checked facets */
    const createNewCityArr = () => {
        /* if a city has been checked, we'll use cityCheckboxValues to populate the facets, otherwise, lets use data.aggregations.stateslist.buckets */
        let final_list_of_cities = [];


        console.log("CHK Values: " + JSON.stringify(cityCheckboxValues));    



        /*
            IF a city is already checked, keep the previous set of values
            OR if a state was already checked and filtering by facets show no results, keep the city values  
        */



        //if (city_is_checked || (state_is_checked && data.hits.total.value === 0)) {
        if (stateFacetsChecked.current[0] > 0) {    
            console.log("City Data: Use current list");
            final_list_of_cities = cityCheckboxValues;
        }
        else {
            //loop through each state from search data
            data.aggregations.stateslist.buckets.forEach(state => {

                /* extract each city and add teh state to it so we have
                * before: {"key":" Atchison ","doc_count":1},{"key":" Lawrence","doc_count":1}
                *after {"key":" Atchison ","doc_count":1,"state":"KS"},{"key":" Lawrence","doc_count":1,"state":"KS"}
                */ 
                console.log("City Data: Use Buckets");
                let city_arr = state["city-list"].buckets.map(s => ({...s, state:state.key}))

                //take each city object and push to final_list_of_cities array
                city_arr.forEach(city => {
                    //city.key = city.key.trim()
                    final_list_of_cities.push(city) 
                })

            })  

            //reorder by alpha since we had to trim leading spaces
            //final_list_of_cities.sort((a,b)=> (a.key.toLowerCase() > b.key.toLowerCase() ? 1 : -1)) //sort by alpha
        }


        return final_list_of_cities
    }

    const buildCategoryMarkup = () => {
        if (typeof data.hits !== 'undefined') {
           
            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from categoryCheckboxValues
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if ((categoryCheckboxValues.current.length > 0 && (firstFacetSelected.current === "cat" || data.hits.total.value === 0))) {

                //console.log("Use catvalues: " + JSON.stringify(categoryCheckboxValues.current))
                return (
                    <ul class="filter-category filter-list" aria-label="Filter by job category" data-filter-list="category">
                    {categoryCheckboxValues.current.map((row, index) => (
                        <li>
                            <input id={"cat"+index} class="cat-chk" name={"cat"+index} type="checkbox" data-type="cat" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                            <label for={"cat"+index}><span>{row["cleaned_key"]} ({row["doc_count"]})</span></label>
                        </li>
                    ))}
                    </ul>
                )    
            }
            else {


                //remove main cat from categories
                data.aggregations.categorieslist.buckets.forEach((row) => {
                    row["cleaned_key"] = removeMainCat(row["key"]); 
                });
            
                //reorder by alpha
                data.aggregations.categorieslist.buckets.sort((a,b)=> (a.cleaned_key.toLowerCase() > b.cleaned_key.toLowerCase() ? 1 : -1)) //sort by alpha


                //console.log("Don't Use catvalues: " + JSON.stringify(checkboxes))
                categoryCheckboxValues.current = data.aggregations.categorieslist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions

                return (
                    <ul class="filter-category filter-list" aria-label="Filter by job category" data-filter-list="category">
                    {data.aggregations.categorieslist.buckets?.map((row, index) => (
                        <li>
                            <input id={"cat"+index} class="cat-chk" name={"cat"+index} type="checkbox" data-type="cat" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                            <label for={"cat"+index}><span>{row["cleaned_key"]} ({row["doc_count"]})</span></label>
                        </li>
                    ))}
                    </ul>
                )
            }
    
           
        }
    }
    
    const buildTypeMarkup = () => {
        if (typeof data.hits !== 'undefined') {
            
            /*
            data.aggregations.typelist.buckets.forEach((row, index, object) => {
                if (row["key"].match(/Any Of These/i)) {
                    object.splice(index, 1); //remove "Any Of These"
                }
            })
            */

            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from typeCheckboxValues
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if (typeCheckboxValues.current.length > 0 && (firstFacetSelected.current === "type" || data.hits.total.value === 0)) {
                return (
                    <ul class="filter-type filter-list" aria-label="Filter by job type" data-filter-list="type">
                        {typeCheckboxValues.current.map((row, index) => (
                            <li>
                                <input id={"type"+index} class="type-chk" name={"type"+index} type="checkbox" data-type="type" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"type"+index}><span>{FixAnyOfTheseJobType(row["key"])} ({row["doc_count"]})</span></label>
                            </li>
                        ))} 
                    </ul>
                )
            } 
            else {
                typeCheckboxValues.current = data.aggregations.typelist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions
                return (
                    <ul class="filter-type filter-list" aria-label="Filter by job type" data-filter-list="type">
                        {data.aggregations.typelist.buckets?.map((row, index) => (
                             <li>
                                <input id={"type"+index} class="type-chk" name={"type"+index} type="checkbox" data-type="type" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"type"+index}><span>{FixAnyOfTheseJobType(row["key"])} ({row["doc_count"]})</span></label>
                            </li>
                        ))}    
                        

                    </ul>
                )
            }

           
        }
    }
    
    const buildStateMarkup = () => {
        if (typeof data.hits !== 'undefined') {

            /*
            * Conditions:
            * IF firstFacetSelected.current we want to keep previous checked values from stateCheckboxValues 
            * OR if facets were clicked and no results showed (mainly with cities) we still want the original facets/facets selections to retain
            */ 
            if (stateCheckboxValues.current.length > 0 && (firstFacetSelected.current === "state" || data.hits.total.value === 0)) {
                return (
                    <ul class="filter-state filter-list" aria-label="Filter by state" data-filter-list="state">
                        {stateCheckboxValues.current.map((row, index) => (
                            <li>
                                <input id={"state"+index} class="st-chk" name={"state"+index} type="checkbox" data-type="state" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"state"+index}><span>{getFullState(row["key"])} ({row["doc_count"]})</span></label>
                            </li>
                        ))}
                    </ul>
                )
            }
            else {
                stateCheckboxValues.current = data.aggregations.stateslist.buckets; //fixes a bug where if facets were selected and a kw search happens with no results, the facets would revert back to "unfiltered" versions
                return (
                    <ul class="filter-state filter-list" aria-label="Filter by state" data-filter-list="state">
                        {data.aggregations.stateslist.buckets?.map((row, index) => (
                            <li>
                                <input id={"state"+index} class="st-chk" name={"state"+index} type="checkbox" data-type="state" value={row["key"]} checked={checkboxes[row["key"]]} onChange={handleChkChange} />
                                <label for={"state"+index}><span>{getFullState(row["key"])} ({row["doc_count"]})</span></label>
                            </li>
                        ))}
                    </ul>
                )
            }
            
        }     
    }
    
    const buildCityMarkup = () => {

        let array_to_use = createNewCityArr(),
            checkbox_group = document.querySelector(".filter-city"),
            states = document.querySelectorAll('.st-chk'),
            state_is_checked = false;


        states.forEach((el) => {
            if (el.checked) {
                state_is_checked = true;
            }
        })


        //reorder by alpha since we had to trim leading spaces
        array_to_use.sort((a,b)=> (a.key.toLowerCase().trim() > b.key.toLowerCase().trim() ? 1 : -1)) //sort by alpha
        
        //console.log("city array_to_use: " + JSON.stringify(array_to_use));
       
        return (
            
            <div class="filter-group filter-city-block show-city-block" data-filter-list-group="city">
                <strong class="filter-group__subhead" onClick={facetToggle} data-filter-list-group-head="city">
                    <span>City</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up filter-group-collapse" style={{display: 'block'}}><polyline points="18 15 12 9 6 15"></polyline></svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down filter-group-expand"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    </span>
                </strong>
                <div class="checkbox checkbox-city checkbox-primary col-xs-12 col-sm-12" data-filter-block="City" aria-label="Filter by job city">
                    <ul class="wrapCheckFilterGroup filter-city filter-list">
                        {array_to_use?.map((row, index) => (  
                            <li>
                                <input id={"city"+index} class="city-chk" name={"city"+index} type="checkbox" data-type="City" value={row["key"]} checked={checkboxes[row["key"]+"_city"]} onChange={handleChkChange} />
                                <label for={"city"+index}><span>{row["key"]}, {row["state"]}  ({row["doc_count"]})</span></label>
                            </li>    
                        ))}
                    </ul>        
                </div>    
               
                {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                {(array_to_use.length>5) ? (<div class="viewMoreWrap"><button class="viewMore" data-toggle="collapse" aria-expanded="false" aria-controls="collapseCity" onClick={e => handleViewMoreFactesClick(e)}>View More</button></div>) : 
                    ((!loading && checkbox_group !== null && checkbox_group.classList.contains("filter-show-all")) && checkbox_group.classList.remove("filter-show-all"))}
            </div>
        )
           
    }

    const cityMarkupWhenToRender = () => {
        
        if (doCityFacetsExist.current === 0) {
            console.log("No Cities Checked: " + doCityFacetsExist.current);
        }
        else {
            console.log("Cities Checked: " + doCityFacetsExist.current);
        }

        //if current states checked === 0 and previous states checked === 0 
        if (stateFacetsChecked.current[0] === 1 && stateFacetsChecked.current[1] === 0 && doCityFacetsExist.current === 0) {
            if (!loading)  {
                console.log("Wait until load: " + stateFacetsChecked.current);
                return buildCityMarkup();
            }  
        }
        else {
            console.log("Don't wait until load: " + stateFacetsChecked.current);
            return buildCityMarkup();
        }
    }

    const handleViewMoreFactesClick = (e) => {
        let facetSibling = e.target.closest(".filter-group").querySelector(".filter-list");

        if (facetSibling.classList.contains("filter-show-all")) {
            facetSibling.classList.remove("filter-show-all")
            e.target.innerHTML = 'View More'
        }
        else {
            facetSibling.classList.add("filter-show-all");
            e.target.innerHTML = 'Show Less'
        }
    }

    //retains search text field query
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }

    //retains checkbox's checked and does part of the state to city display
    const handleChkChange = (event) => {
        const chkbox = event.target ?? event;
        const type = chkbox.getAttribute("data-type");
        const value = (type === "city") ? chkbox.value + "_city" : chkbox.value; //we need to append a _city if its a city so it's unique (DC fix where we may have a city named "DC") 
        const checked = (chkbox.checked) ? "checked" : "";
        setCheckboxes(values => ({...values, [value]: checked}));


        //console.log("checkbox checked: " + JSON.stringify(checkboxes));
    
        //set firstFacetSelected.current if empty 
        if (firstFacetSelected.current === "" && chkbox.checked) {
            firstFacetSelected.current = type
        }


        //handle State Dropdowns to show cities or remove cities NO LONGER NEEDED (setCityCheckboxValues) BUT WE NEED A CHECK IF A STATE FACET HAS BEEN CHECKED 
        if (type === "state") {

            //set how may facets were previously checked 
            stateFacetsChecked.current[1] = stateFacetsChecked.current[0];

            //set how many facets are checked
            (chkbox.checked) ? stateFacetsChecked.current[0]++ : stateFacetsChecked.current[0]--;


            ((stateCheckboxValues.current.length > 0 && firstFacetSelected.current === "state") ? stateCheckboxValues.current : data.aggregations.stateslist.buckets).forEach(bucket => {
                if (bucket.key === value) {
                    
                    //console.log("state bucket" + JSON.stringify(bucket));

                    bucket["city-list"]["buckets"].forEach((city, index) => {

                        
                        //add the state name to city
                        city["state"] = bucket.key;

                        //console.log("city bucket: " + JSON.stringify(city));
                        
                        //ether add or remove depending if we checked or unchecked boxes
                        if (event.target.checked) {
                            setCityCheckboxValues(values => ([...values, city]))

                            //console.log("target state: " + value)
                            
                        }
                        else {
                            setCityCheckboxValues(values => values.filter(el => {return el.key !== city.key})); //either add cities or remove them from the data of dropdowns
                            checkboxes.current = (values => ({...values, ["city"+index]: ""})); //if we unchcecked the state, we need to uncheck its cities

                            /*
                            * If a state is removed from the "tags", the associated cities dont remove. The following is needed to uncheck the cities so when handleSubmit runs,
                            * the associated cities are already unchceked. 
                            */
                            if (document.querySelector(`input[name="city${index}"]`)) document.querySelector(`[name="city${index}"]`).checked=false;
                        }
                        

                    })
                } 
            })
        }

        //console.log("city values: " + JSON.stringify(cityCheckboxValues))
        //console.log(JSON.stringify(checkboxes))

        handleSubmit()
    }

    //saves facet checked data so when a new facet occurs we dont remove the facet data. Only applicable if a filter/facet was checked and for firstFacetSelected.current 
    const saveFacetClickedData = () => {

        /* 
        The forEaches will retain the "firstFacetSelected.current" values or if theres no "firstFacetSelected.current" yet 
        Otherwise we want to retain the new values from  data.aggregations.xxxxlist.buckets 
        */
       
        if (firstFacetSelected.current === "cat") {
            data.aggregations.categorieslist.buckets?.forEach(cat => {
                //console.log("THE CAT: " + JSON.stringify(cat));
                let check_name_match = obj => obj.key === cat.key;
                if (!categoryCheckboxValues.current.some(check_name_match)) categoryCheckboxValues.current = (values => ([...values, cat]))
            })
        }


        if (firstFacetSelected.current === "type") {

            data.aggregations.typelist.buckets?.forEach(type => {
                let check_name_match = obj => obj.key === type.key;
                if (!typeCheckboxValues.current.some(check_name_match)) typeCheckboxValues.current = (values => ([...values, type]))
            })
        }


        //if (firstFacetSelected.current === "state" || firstFacetSelected.current === "") { //8.16.23 mc not syre why i had  || firstFacetSelected.current === ""
        if (firstFacetSelected.current === "state") {
            data.aggregations.stateslist.buckets?.forEach(state => {
                let check_name_match = obj => obj.key === state.key;
                if (!stateCheckboxValues.current.some(check_name_match)) stateCheckboxValues.current = (values => ([...values, state]))
            })
        }



        

        
    }

    const handleSubmit = (event) => {
        let search_params = {},
            category_values = [],
            type_values = [],
            state_values = [],
            city_values = [],
            categories = document.querySelectorAll('.cat-chk'),
            types = document.querySelectorAll('.type-chk'),
            states = document.querySelectorAll('.st-chk'),
            cities = document.querySelectorAll('.city-chk');
        
        resetURLReplaceState();
        //console.log("search: " + JSON.stringify(search_params))

        if (event) {
            event.preventDefault();
            resetFacets(); //we reset the facets if "event" exists which means search btn was clicked. We do this since a KW inout search should clear previous filters.  
            console.log("SEARCH PERFORMED")
        }

        console.log("Submitting");

        //reset
        doCityFacetsExist.current = 0;

        updatePageIndex(1)

           
        
        
        if (inputs.keywords) {
            search_params["keywords"] = inputs.keywords.trim();
        }

        if (!event) {
            //check if categories were selected and add to an array
            categories.forEach((el) => {
                //console.log("EACH CAT:" + el.value)
                if (el.checked) category_values.push(el.value);
            })

            //check if Job types were selected and add to an array
            types.forEach((el) => {
                //console.log("EACH CAT:" + el.value)
                if (el.checked) type_values.push(el.value);
            })

            //check if states were selected and add to an array
            states.forEach((el) => {
                if (el.checked) state_values.push(el.value);
            })

            //check if cities were selected and add to an array
            cities.forEach((el) => {
                if (el.checked) {
                    city_values.push(el.value);
                    //console.log("el.value: " + el.value);
                    //doCityFacetsExist.current = 1;
                }
            })

            if (cities.length) {
                //city exists
                doCityFacetsExist.current = 1;
            }


            //add categories and/or states to search params
            if (category_values.length > 0) search_params["categories"] = category_values 
            if (type_values.length > 0) search_params["types"] = type_values 
            if (state_values.length > 0) search_params["states"] = state_values
            if (city_values.length > 0) search_params["cities"] = city_values


            //if we have some checked facets but the first facet selected checkbox is all unchecked, we need to reset firstFacetSelected.current
            if ((firstFacetSelected.current === "cat" && category_values.length === 0) || 
                (firstFacetSelected.current === "type" && type_values.length === 0) || 
                (firstFacetSelected.current === "state" && state_values.length === 0)) {
                firstFacetSelected.current = ""
            }
    

            //Only retain dropdown facet data if a facet was selected. we excluded city since if no states are checked, city would not be as well.
            //Only retain dropdown facet data if a facet was selected. we excluded city since if no states are checked, city would not be as well.

            /*
            if (category_values.length > 0 || state_values.length > 0 || type_values.length > 0) {
                saveFacetClickedData();  
                window.were_facets_used = true;
                console.log("facets were used");
            }
            else {
                window.were_facets_used = false;
                console.log("facets were not used");
                resetFacets();
            }
            */

            if (Object.keys(checkboxes).length || category_values.length > 0 || state_values.length > 0 || type_values.length > 0) {
                saveFacetClickedData();
                window.were_facets_used = true;
            }
            else {
                window.were_facets_used = false;
                resetFacets();
            }
        }
        
        //update the job params which will trigger search
        updateJobParams(search_params);
        
    }

    const mobileMenuHide = () => {
        document.body.classList.contains("mobile-facets-active") && document.body.classList.remove("mobile-facets-active");
        if (document.querySelector(".job-facets-column").classList.contains("show")) {
            document.querySelector(".job-facets-column").classList.remove("show");
            document.querySelector(".job-results-column").classList.remove("blurred");
        }
        else {
            document.querySelector(".job-facets-column").classList.add("show");
            document.querySelector(".job-results-column").classList.add("blurred");
        }

        scrollToTopOfJobs();
    }

    const facetToggle = (e) => {

        e.stopPropagation();

        //check if click was .filter-group__subhead or not. we need it to be filter-group__subhead
        let newTarget = (e.target.classList.contains("filter-group__subhead")) ? e.target : e.target.closest(".filter-group__subhead");
    
        if (newTarget.querySelector(".filter-group-collapse").style.display === 'none') {
            newTarget.querySelector(".filter-group-collapse").style.display = 'block';
            newTarget.querySelector(".filter-group-expand").style.display = 'none';
            newTarget.parentNode.querySelector(".filter-list").style.display = 'block';
            if (newTarget.parentNode.querySelector(".view-more") !== null) newTarget.parentNode.querySelector(".view-more").style.display = 'block';
        }
        else {
            newTarget.querySelector(".filter-group-collapse").style.display = 'none';
            newTarget.querySelector(".filter-group-expand").style.display = 'block';
            newTarget.parentNode.querySelector(".filter-list").style.display = 'none';
            if (newTarget.parentNode.querySelector(".view-more") !== null) newTarget.parentNode.querySelector(".view-more").style.display = 'none';
        }
    }


    return (
        <>
         {createPortal(
            <form Id="job-search-form" onSubmit={handleSubmit} aria-label="Search our jobs">
                <div class="input-text-wrap text-left">
                    <input type="text" id="inputKW" name="keywords" placeholder="Job title, location, or keyword" title="Search Jobs by Job title, location, or keyword" value={inputs.keywords}  onChange={handleChange} />
                </div>
                <input type="submit" name="Search"id="btn-searchJobs" class="btn" value="Search Jobs" />
            </form>
            ,document.getElementById("jobSearchbar")
        )}

        {(typeof data.hits !== 'undefined') &&
        <div id="MainPlaceHolder_JobListing_uxFacets" class="job-facets-column" style={(data.hits.total?.value === 0 && !window.were_facets_used) ? ({display: 'none'}) : ({})}>
            <div class="h3">Filter by</div>
            <button class="job-filter-close-mobile view-filters-toggle" aria-label="Hide job filters" onClick={mobileMenuHide}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
            <div class="job-facets__filters-wrap">
                

                <div class="filter-group filter-cat-block" data-filter-list-group="category" style={(!loading && document.querySelector(".filter-category") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <strong class="filter-group__subhead" onClick={facetToggle} data-filter-list-group-head="category">
                        <span>Category</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up filter-group-collapse" style={{display: 'block'}}><polyline points="18 15 12 9 6 15"></polyline></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down filter-group-expand"><polyline points="6 9 12 15 18 9"></polyline></svg>
                        </span>
                    </strong>
                    {buildCategoryMarkup()}
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(typeof(document.querySelectorAll('.cat-chk')) !== 'undefined' && document.querySelectorAll('.cat-chk').length>5) ? (<div class="viewMoreWrap"><button class="view-more" data-toggle="collapse" aria-expanded="false" aria-controls="collapseSubCategory" data-filter-list-toggle="category" onClick={e => handleViewMoreFactesClick(e)}>View More</button></div>) : 
                        ((!loading && document.querySelector(".filter-category").classList.contains("filter-show-all")) && document.querySelector(".filter-category").classList.remove("filter-show-all"))}
                </div>

                <div class="filter-group filter-type-block" style={(!loading && document.querySelector(".filter-type") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <strong class="filter-group__subhead" onClick={facetToggle} data-filter-list-group-head="type">
                        <span>Type</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up filter-group-collapse" style={{display: 'block'}}><polyline points="18 15 12 9 6 15"></polyline></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down filter-group-expand"><polyline points="6 9 12 15 18 9"></polyline></svg>
                        </span>
                    </strong>
                    {buildTypeMarkup()}
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(typeof(document.querySelectorAll('.type-chk')) !== 'undefined' && document.querySelectorAll('.type-chk').length>5) ? (<div class="viewMoreWrap"><button class="view-more" data-toggle="collapse" aria-expanded="false" aria-controls="collapseType" onClick={e => handleViewMoreFactesClick(e)} >View More</button></div>) : 
                        ((!loading && document.querySelector(".filter-type").classList.contains("opened")) && document.querySelector(".filter-type").classList.remove("opened"))}
                </div>

                <div class="filter-group filter-state-block" style={(!loading && document.querySelector(".filter-state") === null) ? ({display:'none'}) : ({display:'block'})}>
                    <strong class="filter-group__subhead" onClick={facetToggle} data-filter-list-group-head="state">
                        <span>State</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up filter-group-collapse" style={{display: 'block'}}><polyline points="18 15 12 9 6 15"></polyline></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down filter-group-expand"><polyline points="6 9 12 15 18 9"></polyline></svg>
                        </span>
                    </strong>
                    {buildStateMarkup()}    
     
                    {/*removes view more if greater than 5 results otherwise remove the opened class if it exists */}
                    {(document.querySelector(".filter-state") !== null && typeof(document.querySelectorAll('.st-chk')) !== 'undefined' && document.querySelectorAll('.st-chk').length>5) ? (<div class="viewMoreWrap"><button class="view-more" data-toggle="collapse" aria-expanded="false" aria-controls="collapseSubState" onClick={e => handleViewMoreFactesClick(e)}>View More</button></div>) : 
                        ((!loading && document.querySelector(".filter-state").classList.contains("opened")) && document.querySelector(".filter-state").classList.remove("opened"))}
                </div>
                
                {(cityCheckboxValues.length > 0) && (cityMarkupWhenToRender())}
                {/*(cityCheckboxValues.length > 0) && (console.log("chkboxvalues for city exist: " + JSON.stringify(cityCheckboxValues)))*/}

                {(!loading) && <>
                    <div class="job-filter-clearfacets-wrap">
                        <button class="job-filter-clearfacets" aria-label="Clear job filter selections" onClick={resetFacets}>Clear<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
                    </div>
                    <div class="job-filter-apply-change-filter"><button class="btn btn-close-facets filter-search-btn facet-closer" aria-label="Apply filter changes" onClick={mobileMenuHide}>Apply Changes</button></div>
                </>}
            </div>
        </div>
        }
        </>
    )
}


export default Facets;